import React from "react";
import "./Terms.css";

export default function Terms() {
  return (
    <main className="terms_container">
     <header>
  <h1>Terms of Use</h1>
  <p>
    THE TERMS OF THIS MASTER SERVICES AGREEMENT (“AGREEMENT”) APPLY TO ANY AND ALL
    SERVICES (AS DEFINED BELOW) OF OUROFFICE, INC. (“COMPANY”). THESE TERMS APPLY TO ANY
    AND ALL OF YOUR ACCESS TO AND USE OF THE “PORTAL.OUROFFICE.IO” SITE AND TO ALL OTHER
    OUROFFICE WEBSITES (WHETHER VIA DESKTOP OR MOBILE), INCLUDING THOSE ASSOCIATED WITH
    THE TRIVVY PRODUCT (INCLUDING GOTRIVVY.COM AND TRIVVY.OUROFFICE.IO), WHICH IS A PRODUCT
    OPERATED BY OUROFFICE, INC, (“WEBSITE(S),” OR “SITE(S)”), APPLICATIONS, APPS, AS WELL AS
    ALL MEANS OF WRITTEN AND ORAL COMMUNICATIONS, INCLUDING VIA EMAIL, CHAT, INSTANT
    MESSAGE, AND THE LIKE, AND VOICE COMMUNICATIONS (REFERRED TO HEREIN INDIVIDUALLY AND
    COLLECTIVELY, INCLUDING WEBSITES OR SITES, AS “SERVICES”, “PLATFORMS” OR “PLATFORM”).
    THESE PLATFORMS AND OUROFFICE ARE OWNED AND/OR OPERATED BY OR FOR OUROFFICE, INC.,
    AND/OR ONE OR MORE OF ITS SUBSIDIARIES (“COMPANY,” “US,” “WE,” “OUR”). IF YOU DO NOT
    AGREE TO THESE TERMS, YOU ARE NOT AUTHORIZED TO USE OUROFFICE’S SERVICES OR PLATFORMS.
    ACCESSING OR USING ANY SERVICES OR PLATFORM, INCLUDING WHETHER OR NOT YOU CLICK THE
    “CONTINUE” BUTTON, CONSTITUTES YOUR ELECTRONIC SIGNATURE AND AGREEMENT THAT YOU, ANY
    ENTITY YOU REPRESENT AND ANY AFFILIATE OF SUCH ENTITY (COLLECTIVELY, “CUSTOMER”) HAVE
    READ AND ARE BOUND BY THIS AGREEMENT IN PRIORITY TO ALL OTHER TERMS. THIS AGREEMENT IS
    ENTERED INTO AS OF THE DATE YOU ACCEPT THESE TERMS OR FIRST USE THE APPLICATION
    SERVICES (“EFFECTIVE DATE”).
  </p>

  <p>
    <strong>Corporate Relationship.</strong> OurOffice, Inc. is the registered business
    entity and the owner of all Services described in this Agreement. Trivvy (accessible at{" "}
    <a href="https://www.gotrivvy.com" target="_blank">gotrivvy.com</a>) is a product operated under
    OurOffice, Inc. The Company’s corporate domain is{" "}
    <a href="https://www.ouroffice.io"target="_blank">ouroffice.io</a>, which is used for company and
    administrative communications. All references in this Agreement to “Company,” “us,”
    “we,” or “our” apply equally to Trivvy as a product offering of OurOffice, Inc., and
    this Agreement governs Customer’s use of all Company Services, whether accessed through
    ouroffice.io, gotrivvy.com, or any related application or platform.
  </p>

  <p>
    <strong>Data Privacy and Consent.</strong> Company collects and processes Customer
    information, including phone numbers, solely for the purpose of providing and
    supporting the Services. Customer phone numbers are never sold, rented, or shared with
    third parties or affiliates for marketing or promotional purposes. Mobile numbers are
    used only to deliver Service-related messages such as authentication codes,
    notifications, customer communications, or survey participation requests.
  </p>

  <p>
    Company requires <em>prior, express consent</em> from end users before sending SMS or
    other mobile communications, and provides clear opt-out mechanisms in each message as
    required by law and industry standards. Consent is recorded and may be withdrawn at any
    time by the user.
  </p>

  <p>
    All personal information collected through OurOffice or Trivvy platforms is handled in
    accordance with this Agreement and Section 4: Privacy Policy and Data Use. Company
    implements commercially reasonable technical and organizational measures (including
    encryption, access controls, and monitoring) to protect Customer Data and maintain the
    security, confidentiality, and integrity of all information, consistent with SOC2
    framework and other applicable standards.
  </p>
</header>

<section>
  <h2>1. Services and Support</h2>
  <ol>
    <li>
      Subject to the terms of this Agreement, Company will use commercially reasonable
      efforts to provide Customer with the Services. Company reserves the right at its sole
      discretion to refuse or cancel Services.
    </li>
    <li>
      Company will use commercially reasonable efforts to (i) maintain the security and
      integrity of the Services and any electronic data or information provided by
      Customer, and (ii) provide Customer with reasonable support in accordance with
      Company’s standard practices to support Customer success.
    </li>
  </ol>
</section>

<section>
  <h2>2. Restrictions and Responsibilities</h2>
  <ol>
    <li>
      Subject to the terms of this Agreement, Company grants Customer a non-transferable,
      non-sublicensable, non-exclusive, revocable license to access and use the Services.
      Customer will not, directly or indirectly: reverse engineer, decompile, disassemble
      or otherwise attempt to discover the source code, object code or underlying
      structure, ideas, know-how, processes, or algorithms relevant to the Services or any
      software, documentation or data related to the Services (“Software”) or support
      provided by OurOffice employees or associates; modify, translate, or create
      derivative works based on the Services or any Software (except to the extent
      expressly permitted by Company or authorized within the Services); use the Services
      or any Software for time sharing or service bureau purposes or otherwise reselling or
      providing the Services for the benefit of any third party; or remove any proprietary
      notices or labels.
    </li>
    <li>
      Customer represents, covenants, and warrants that Customer will use the Services only
      in compliance with this Agreement and all applicable laws and regulations. Customer
      agrees to indemnify and hold Company harmless against any damages, losses,
      liabilities, settlements and expenses (including reasonable attorneys’ fees)
      resulting from any third-party claim or action to the extent such claim arises from
      an alleged violation of the foregoing or otherwise from Customer’s use of the
      Services. Although Company has no obligation to monitor Customer’s use, Company may
      do so and may suspend or restrict any use it believes may be or is alleged to be in
      violation.
    </li>
    <li>
      Customer is responsible for obtaining and maintaining any equipment and ancillary
      services needed to connect to, access or use the Services, including, without
      limitation, modems, hardware, servers, software, operating systems, networking, and
      web servers (“Equipment”). Customer is responsible for maintaining the security of
      the Equipment, Customer account, passwords (including administrative and user
      passwords) and files, and for all uses of Customer account or Equipment with or
      without Customer’s knowledge or consent. If Customer believes security has been
      compromised, it must immediately notify Company and take action to remediate.
    </li>
  </ol>
</section>

<section>
  <h2>3. Confidentiality; Proprietary Information</h2>
  <ol>
    <li>
      Each party receiving information (the “Receiving Party”) understands that the other
      party disclosing such information (the “Disclosing Party”) has disclosed or may
      disclose business, technical or financial information relating to the Disclosing
      Party’s business (“Proprietary Information”). Proprietary Information of Company
      includes non-public information regarding features, functionality, processes, and
      performance of the Services. Proprietary Information of Customer includes non-public
      data provided by Customer to Company to enable provision of the Services (“Customer
      Data”). The Receiving Party agrees: (i) to take reasonable precautions to protect
      such Proprietary Information, and (ii) not to use (except in performance of the
      Services or as otherwise permitted herein) or divulge to any third person any such
      Proprietary Information. The foregoing does not apply to information after ten (10)
      years following disclosure or any information the Receiving Party can document: (a)
      is or becomes generally available to the public; (b) was lawfully in its possession
      or known without breach of confidentiality prior to receipt; (c) was rightfully
      disclosed without restriction by a third party; (d) was independently developed
      without use of Proprietary Information; or (e) is required to be disclosed by law,
      regulation, or legal process.
    </li>
    <li>
      Customer owns all right, title and interest in and to the Customer Data. Customer
      provides Company a nonexclusive, limited, royalty-free, fully-paid-up license only to
      the extent necessary for Company to provide the Services. Company owns and retains
      all right, title and interest in and to (a) the Services and Software, including all
      improvements, enhancements or modifications thereto, (b) any software, applications,
      inventions or other technology developed in connection with implementation of the
      Services or support, any feedback on the Services or Software provided by Customer,
      and (c) all intellectual property rights related thereto.
    </li>
    <li>
      Notwithstanding anything to the contrary, Company may collect and analyze data and
      other information relating to the provision, use and performance of various aspects
      of the Services and related systems, technologies, and processes (including
      information concerning Customer Data and data derived therefrom). Company may use
      such information and data to improve and enhance the Services and for other
      development, diagnostic and corrective purposes, and may disclose such data solely
      in aggregate and/or de-identified form in connection with its business. Company will
      not identify Customer in such disclosure. No rights or licenses are granted except as
      expressly set forth herein.
    </li>
  </ol>
</section>

<section>
  <h2>4. Privacy Policy and Data Use</h2>
  <ol>
    <li>
      <strong>Collection and Purpose.</strong> Company collects Customer Data, including
      but not limited to names, email addresses, phone numbers, and usage information, only
      as necessary to provide and improve the Services. Phone numbers are used exclusively
      for security purposes (e.g., multi-factor authentication), service notifications,
      messaging, survey participation, and other direct service-related communications.
    </li>
    <li>
      <strong>Consent for Communications.</strong> Company requires clear, prior, and
      express consent from end users before sending SMS, email, or other electronic
      communications. Each message includes an opt-out mechanism (e.g., “Reply STOP to
      unsubscribe”) consistent with applicable law and industry standards. Consent is
      recorded and may be withdrawn by the user at any time.
    </li>
    <li>
      <strong>No Sale of Mobile Numbers or Personal Data.</strong> Customer phone numbers
      and other personal identifiers are never sold, rented, or shared with third parties
      or affiliates for marketing or promotional purposes. Customer Data is used solely for
      service delivery, support, diagnostics, security, and product improvement.
    </li>
    <li>
      <strong>Limited Disclosure.</strong> Company may share Customer Data with trusted
      service providers (such as hosting, infrastructure, or communications vendors,
      including SMS providers) only to the extent strictly necessary to provide the
      Services. All such providers are bound by confidentiality and data-protection
      obligations. Company will not disclose Customer Data to any other third party except
      as required by law.
    </li>
    <li>
      <strong>Data Security.</strong> Company implements and maintains commercially
      reasonable administrative, technical, and physical safeguards to protect Customer
      Data against unauthorized access, use, or disclosure. These safeguards include,
      without limitation, encryption in transit and at rest where applicable, access
      controls, monitoring, and regular reviews of system integrity. Company’s practices
      are designed to align with SOC 2 principles of security, confidentiality, and
      integrity.
    </li>
    <li>
      <strong>Aggregate and De-identified Use.</strong> Company may collect and analyze
      aggregate and de-identified information regarding the provision, use, and performance
      of the Services. Such data may be used for diagnostics, service enhancement,
      analytics, and research purposes, provided it cannot reasonably be used to identify
      Customer or end users.
    </li>
    <li>
      <strong>Retention and Deletion.</strong> Company retains Customer Data only for as
      long as necessary to provide the Services or comply with legal obligations. Upon
      request or termination, Company will delete or return Customer Data in accordance
      with applicable law and Company’s standard data-retention practices.
    </li>
  </ol>
</section>

<section>
  <h2>5. Indemnity</h2>
  <ol>
    <li>
      Company shall indemnify and hold harmless Customer from liability to third
      parties resulting from infringement by the Services of any United States
      patent, copyright, or misappropriation of any trade secret, provided that:
      (i) Company is promptly notified of any and all threats, claims,
      communications or proceedings; (ii) Company is given sole control over
      defense and settlement; and (iii) Customer cooperates fully. Company will
      not be responsible for any costs incurred by Customer in such cooperation,
      or for any settlement or admission not approved by Company in writing. The
      foregoing does not apply to portions/components of the Services (a) not
      created by Company, (b) created in whole or in part in accordance with
      Customer’s specifications, (c) modified after delivery by Company, (d)
      combined with other products, processes or materials where the alleged
      infringement relates to such combination, (e) where Customer continues
      allegedly infringing activity after being notified thereof or after being
      informed of modifications that would have avoided the alleged
      infringement, or (f) where Customer’s use is not in accordance with this
      Agreement and related documentation.
    </li>
  </ol>
</section>

<section>
  <h2>6. Payment of Fees</h2>
  <ol>
    <li>
      Customer will pay Company the applicable fees described in the Order Form
      for the Services <strong>or equivalent</strong> in accordance with the
      terms therein (“Fees”). If Customer’s use of the Services exceeds the
      Service Capacity set forth in the Order Form or otherwise exceeds usage
      limitations, Customer shall be billed for such usage and agrees to pay the
      additional fees. Company may change Fees or institute new charges at the
      end of the Initial Service Term or then-current renewal term, upon thirty
      (30) days’ prior notice (which may be sent by email). If Customer believes
      it has been billed incorrectly, it must contact Company no later than
      sixty (60) days after the closing date on the first allegedly incorrect
      statement to receive an adjustment or credit. Inquiries should be directed
      to <strong>support@ouroffice.io</strong>.
    </li>
    <li>
      Company may bill by invoice or equivalent; full payment is due upon
      receipt and prior to the start of service, unless otherwise agreed upon by
      parties. Any outstanding balance beyond the due date is subject to a
      finance charge of 1.5% per month, or the maximum permitted by law,
      whichever is lower, plus all expenses of collection, and may result in
      immediate termination of the Services. Customer is responsible for all
      taxes associated with the Service other than U.S. taxes based on Company’s
      net income.
    </li>
  </ol>
</section>

<section>
  <h2>7. Term and Termination</h2>
  <ol>
    <li>
      Subject to earlier termination as provided below, and unless intended for
      pilot use, this Agreement is for the Initial Service Term specified in an
      “Order Form” (in a format provided by Company or as otherwise agreed by
      the parties), and renews automatically for additional periods of the same
      duration (collectively, the “Term”), unless either party requests
      termination at least thirty (30) days prior to the end of the then-current
      term.
    </li>
    <li>
      In addition to other remedies, either party may terminate this Agreement
      upon thirty (30) days’ notice (or without notice in the case of
      nonpayment) if the other party materially breaches. Customer will pay in
      full for the Services up to and including the last day on which Services
      are provided. All sections which by their nature should survive
      termination will survive, including accrued rights to payment,
      confidentiality, warranty disclaimers, and limitations of liability.
    </li>
  </ol>
</section>

<section>
  <h2>8. Warranty and Disclaimer</h2>
  <ol>
    <li>
      Company shall use commercially reasonable efforts consistent with
      prevailing industry standards to maintain the Services in a manner which
      minimizes errors and interruptions and shall perform implementation in a
      professional and workmanlike manner. The Services may be unavailable for
      scheduled maintenance or unscheduled emergency maintenance by Company or
      third-party providers, or for other causes beyond Company’s reasonable
      control. Company will use reasonable efforts to provide advance notice of
      scheduled disruptions. COMPANY DOES NOT WARRANT THAT THE SERVICES WILL BE
      UNINTERRUPTED OR ERROR FREE, NOR DOES IT MAKE ANY WARRANTY AS TO RESULTS
      THAT MAY BE OBTAINED FROM USE. EXCEPT AS EXPRESSLY SET FORTH, THE SERVICES
      AND IMPLEMENTATION ARE PROVIDED “AS IS” AND COMPANY DISCLAIMS ALL
      WARRANTIES, EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF
      MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
    </li>
  </ol>
</section>

<section>
  <h2>9. Limitation of Liability</h2>
  <ol>
    <li>
      <strong>Limitation of Remedies and Damages.</strong> IN NO EVENT SHALL
      COMPANY, NOR ITS DIRECTORS, EMPLOYEES, AGENTS, PARTNERS, SUPPLIERS OR
      CONTENT PROVIDERS, BE LIABLE UNDER CONTRACT, TORT, STRICT LIABILITY,
      NEGLIGENCE OR ANY OTHER THEORY WITH RESPECT TO THIS AGREEMENT (I) FOR ANY
      LOST PROFITS, DATA LOSS, COST OF PROCUREMENT OF SUBSTITUTE GOODS OR
      SERVICES, OR SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL
      DAMAGES OF ANY KIND, (II) FOR ANY BUGS, VIRUSES, TROJAN HORSES, OR THE
      LIKE (REGARDLESS OF SOURCE OF ORIGINATION), OR (III) FOR ANY DIRECT
      DAMAGES IN EXCESS OF THE GREATER OF (IN THE AGGREGATE) $100 OR THE ANNUAL
      SERVICE FEE PAID UNDER THE AGREEMENT (OR PRO RATA PORTION THEREOF PER THE
      SERVICE TERM).
    </li>
  </ol>
</section>

<section>
  <h2>10. Miscellaneous</h2>
  <ol>
    <li>
      If any provision of this Agreement is unenforceable or invalid, that
      provision will be limited or eliminated to the minimum extent necessary so
      that this Agreement will otherwise remain in full force and effect. This
      Agreement is not assignable, transferable or sublicensable by either party
      except with the other party’s prior written consent, provided that either
      party may assign or transfer this Agreement in connection with the sale of
      all or substantially all of its stock, business, or assets to which this
      Agreement relates (whether by merger, change in control, asset purchase or
      otherwise) without the other party’s consent. This Agreement is the
      complete and exclusive statement of the mutual understanding of the
      parties and supersedes all previous agreements and communications relating
      to its subject matter; all waivers and modifications must be in a writing
      signed by both parties, except as otherwise provided herein. No agency,
      partnership, joint venture, or employment is created as a result of this
      Agreement and Customer has no authority to bind Company. In any action to
      enforce rights under this Agreement, the prevailing party is entitled to
      recover costs and attorneys’ fees. All notices will be in writing and
      deemed given when received if personally delivered; when receipt is
      electronically confirmed if sent by facsimile or email; the day after
      sending by recognized overnight delivery; and upon receipt if sent by
      certified or registered mail, return receipt requested. This Agreement is
      governed by the laws of the State of California without regard to conflict
      of laws. All disputes shall be adjudicated in the federal or state courts
      located in Los Angeles, California. The parties shall work in good faith
      to issue at least one mutually agreed press release. Both parties may use
      each other’s logos, and disclose the general nature of this agreement in
      marketing efforts. Company may use any testimonial by Customer in its
      marketing materials. Customer agrees to reasonably cooperate with Company
      to serve as a reference upon request.
    </li>
    <li>
      Company may modify the Terms and impose new or additional terms on
      Customer’s use of the Services or any Platform at any time in its sole
      discretion. Company may optionally notify Customer by email to the
      Administrator address provided. Such modifications are effective
      immediately and incorporated into this Agreement. Continued use of the
      Services constitutes acceptance. Except as posted by Company (including on
      the Websites or any Platform), the Terms will not be amended, and no terms
      will be waived, except in a writing signed by Customer and an authorized
      representative of Company. For this provision, a “writing” does not
      include an email, text, chat, or the like. Company is not obligated to
      provide notice of modifications by any method other than posting the
      amended Terms; such posting is sufficient notice. Company may include the
      revised and effective date of the Terms. By using any Services or Platform
      following any modifications, Customer agrees to be bound by such
      modifications.
    </li>
  </ol>
</section>

    </main>
  );
}
